import React from 'react';
import { Link } from 'react-router-dom';

const ChefThankYou = props => {
  return (
    <div className="on-boarding-thank-you">
      <div className="on-boarding-thank-you__wrap">
        <div className="on-boarding__h1">Welcome to The Culinistas!</div>
        <div className="on-boarding__p">
          We value not only your technical skills, but also your creativity and
          your hospitality. Our recipe cards, grocery lists, and other materials
          are meant to empower you to create the most delicious food for your
          clients.
        </div>
        <div className="on-boarding-thank-you__cta">
          <Link to="/" className="btn btn--solid-blue">
            View My Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ChefThankYou;



// WEBPACK FOOTER //
// ./src/components/onboarding/chef/ChefThankYou.js